export default "__VITE_ASSET__CKjcKQCZ__"